import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mt-0" }
const _hoisted_2 = {
  key: 0,
  d: "M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z",
  "fill-rule": "evenodd",
  sandboxuid: "0"
}
const _hoisted_3 = {
  key: 1,
  d: "M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z",
  sandboxuid: "0"
}
const _hoisted_4 = { class: "conditions v-theme--light" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = {
  version: "1.2",
  style: {"overflow":"visible","width":"299px","height":"1px","opacity":"1","mix-blend-mode":"normal","rotate":"0deg"}
}
const _hoisted_8 = { class: "d-flex search-buttons" }

import ManagementOfficeAutoComplete from '@/components/AutoCompletes/ManagementOfficeAutoComplete.vue';
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import DepartmentAutoComplete from '@/components/AutoCompletes/DepartmentAutoComplete.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getDepartmentResponse from '@/types/responses/getDepartment';
import {
  OPERATION_OFFICE_TYPE,
    ITTENKO_V2,
    ITTENKO_V3,
    WHITE_SAFETY
} from '@/services/consts';
import { Ref, ref, computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchFilter',
  props: {
    loading: { type: Boolean }
  },
  emits: ['search'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const OPERATION_OFFICES_FILTER_PARAMS = {
  tenko_type: [WHITE_SAFETY, ITTENKO_V2, ITTENKO_V3],
}
const hide: Ref<boolean> = ref(false)
const managementOffice: Ref<getManagementOffice | undefined> = ref()
const operationOffice: Ref<getOperationOffice | undefined> = ref()
const department: Ref<getDepartmentResponse | undefined> = ref()
const accountName: Ref<string | null> = ref(null)
const errorMessages: Ref<{[key: string]: string[]}> = ref({
  operationOffice: []
})

const searchAreaClass = computed(() => {
  return hide.value ? "search-area-hide p-4" : "search-area p-4"
})

const title = computed(() => {
  return hide.value ? "" : i18n.global.t('pages.common.filter.title')
})

const searchBtnLabel = computed(() => {
  return props.loading ? i18n.global.t('pages.common.button.loading') : i18n.global.t('pages.common.button.exec');
})

function handleClickSearch() {
  if (!validation()) {
    return;
  }
  resetValidationMessages()
  const params = {
    type_class: OPERATION_OFFICE_TYPE,
    officeable_id: operationOffice.value?.id ?? null,
    account_name: accountName.value,
    department_id: department.value?.id ?? null,
  }
  emits('search', params)
}

function validation() {
  if (!operationOffice.value) {
    errorMessages.value.operationOffice = [i18n.global.t('pages.tenkoAssociation.errorMessage.operationOffice.required')];
    return false;
  }
  return true;
}

function clearForm() {
  managementOffice.value = undefined
  operationOffice.value = undefined
  department.value = undefined
  accountName.value = null
}

function resetValidationMessages() {
  errorMessages.value.operationOffice = []
}

function toggleSidebar() {
  hide.value = !hide.value
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(searchAreaClass.value)
  }, [
    _createElementVNode("h4", _hoisted_1, [
      _createTextVNode(_toDisplayString(title.value) + " ", 1),
      (_openBlock(), _createElementBlock("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fit: "",
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        sandboxuid: "0",
        onClick: toggleSidebar
      }, [
        (hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
          : (_openBlock(), _createElementBlock("path", _hoisted_3))
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`strpied-tabled-with-hover ${hide.value ? 'd-none' : '' }`)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ManagementOfficeAutoComplete, {
          modelValue: managementOffice.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((managementOffice).value = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(SingleOperationOfficeAutoComplete, {
          modelValue: operationOffice.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((operationOffice).value = $event)),
          managementOffice: managementOffice.value,
          errorMessages: errorMessages.value.operationOffice,
          filterParams: OPERATION_OFFICES_FILTER_PARAMS,
          class: "pt-2"
        }, null, 8, ["modelValue", "managementOffice", "errorMessages"]),
        _createVNode(DepartmentAutoComplete, {
          modelValue: department.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((department).value = $event)),
          operationOffices: operationOffice.value ? [operationOffice.value] : undefined,
          class: "pt-2"
        }, null, 8, ["modelValue", "operationOffices"]),
        _createVNode(_component_v_text_field, {
          class: "pt-2",
          label: _unref(i18n).global.t('pages.tenkoAssociation.filter.driverName'),
          modelValue: accountName.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((accountName).value = $event)),
          outlined: "",
          "hide-details": "auto"
        }, null, 8, ["label", "modelValue"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("defs", null, [
                _createElementVNode("path", {
                  id: "path-1650848226989195",
                  d: "M1126 703 C1126 703 1425 703 1425 703"
                })
              ], -1),
              _createElementVNode("g", { transform: "translate(-1126, -703)" }, [
                _createElementVNode("path", {
                  style: {"stroke":"rgb(194, 186, 186)","stroke-width":"1","stroke-linecap":"butt","stroke-linejoin":"miter","fill":"none"},
                  d: "M1126 703 C1126 703 1425 703 1425 703"
                })
              ], -1)
            ]))]))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_btn, {
              class: "ma-2 exec-btn",
              onClick: handleClickSearch,
              disabled: props.loading,
              style: _normalizeStyle({
                backgroundColor : props.loading ? '#B3B8BB' : ''
              })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(searchBtnLabel.value), 1)
              ]),
              _: 1
            }, 8, ["disabled", "style"]),
            _createVNode(_component_v_btn, {
              class: "ma-2 reset-btn",
              disabled: props.loading,
              onClick: clearForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ], 2)
  ], 2))
}
}

})